/**
 * Meeting Actions
 *
 * Handles meeting single page actions like adding to calendar
 *
 * @param {Object} $ - jQuery object
 * @package
 */

(function ($) {
	'use strict';

	/**
	 * Add to Calendar functionality
	 */
	$(document).ready(function () {
		$('#add-to-calendar').on('click', function (e) {
			e.preventDefault();

			// Get meeting date and time from meta
			const dateElement = $(
				'.meeting-details-box .detail-item:first span:last-child, .meeting-details-box .detail-item:first div span'
			);
			const meetingDateText = dateElement.text().trim();


			// Try multiple date formats
			let day; let month; let year; let time;

			// Format 1: "Monday 29 April 2026, 10:00 AM"
			let dateMatch = meetingDateText.match(
				/\w+\s+(\d+)\s+(\w+)\s+(\d{4}),?\s+(.+)/
			);

			// Format 2: "29 April 2026, 10:00 AM" or "29 April 2026 10:00 AM"
			if (!dateMatch) {
				dateMatch = meetingDateText.match(
					/(\d+)\s+(\w+)\s+(\d{4}),?\s+(.+)/
				);
			}

			// Format 3: "April 29, 2026 11:00 am" (Month first)
			if (!dateMatch) {
				dateMatch = meetingDateText.match(
					/(\w+)\s+(\d+),?\s+(\d{4})\s+(.+)/
				);
				if (dateMatch) {
					month = getMonthNumber(dateMatch[1]);
					day = dateMatch[2].padStart(2, '0');
					year = dateMatch[3];
					time = dateMatch[4];
				}
			}

			// Format 4: "2026-04-29 10:00"
			if (!dateMatch && !month) {
				dateMatch = meetingDateText.match(
					/(\d{4})-(\d{2})-(\d{2})\s+(.+)/
				);
				if (dateMatch) {
					year = dateMatch[1];
					month = dateMatch[2];
					day = dateMatch[3];
					time = dateMatch[4];
				}
			}

			if (!dateMatch && !month) {
				// eslint-disable-next-line no-alert
				alert(
					`Unable to parse meeting date: "${
						meetingDateText
					}". Please add manually.`
				);
				return;
			}

			// Parse standard format (day month year)
			if (!month) {
				day = dateMatch[1].padStart(2, '0');
				month = getMonthNumber(dateMatch[2]);
				year = dateMatch[3];
				time = dateMatch[4];
			}

			// Now get the rest of the data (after date validation)
			const meetingId = $(this).data('meeting-id');
			const meetingTitle = $('h1.entry-title').text().trim();
			const venueElement = $(
				'.meeting-details-box .detail-item:has(.dashicons-location) span:last-child, .meeting-details-box .detail-item:has(.dashicons-location) div span'
			);
			const meetingVenue = venueElement.text().trim() || 'TBD';

			// Convert to ICS format
			const startDateTime = `${year}${month}${day}T${convertTo24Hour(time).replace(':', '')}00`;
			const endDateTime = addOneHour(startDateTime);

			// Create ICS file content
			const icsContent = [
				'BEGIN:VCALENDAR',
				'VERSION:2.0',
				'PRODID:-//Democratic Services//Meeting Calendar//EN',
				'BEGIN:VEVENT',
				`UID:${ meetingId }@${ window.location.hostname}`,
				`DTSTAMP:${ getCurrentTimestamp()}`,
				`DTSTART:${ startDateTime}`,
				`DTEND:${ endDateTime}`,
				`SUMMARY:${ meetingTitle}`,
				`LOCATION:${ meetingVenue}`,
				`DESCRIPTION:${ meetingTitle } - ${ window.location.href}`,
				`URL:${ window.location.href}`,
				'STATUS:CONFIRMED',
				'END:VEVENT',
				'END:VCALENDAR',
			].join('\r\n');

			// Download ICS file
			downloadICS(icsContent, meetingTitle);
		});

		// Print/Download agenda button
		$('#print-agenda').on('click', function (e) {
			e.preventDefault();


			// Look for agenda document specifically marked with data attribute
			let agendaLink = $(
				'.meeting-documents .document-item[data-document-type="agenda"] a'
			).first();

			// Fallback: Look for any document with "agenda" in title
			if (!agendaLink.length) {
				agendaLink = $(
					'.meeting-documents .document-item.agenda-document a'
				).first();
			}

			// Fallback 2: Search by text content
			if (!agendaLink.length) {
				agendaLink = $('.meeting-documents .document-list a')
					.filter(function () {
						const text = $(this).text().toLowerCase().trim();

						return text.includes('agenda');
					})
					.first();
			}

			if (agendaLink.length && agendaLink.attr('href')) {
				const agendaUrl = agendaLink.attr('href');


				// Open agenda document in new tab
				window.open(agendaUrl, '_blank');
			} else {
				// eslint-disable-next-line no-alert
				alert(
					'No agenda document found for this meeting. The agenda may not have been published yet.'
				);
			}
		});
	});

	/**
	 * Get month number from name
	 *
	 * @param {string} monthName Month name
	 * @return {string} Month number (01-12)
	 */
	function getMonthNumber(monthName) {
		const months = {
			January: '01',
			February: '02',
			March: '03',
			April: '04',
			May: '05',
			June: '06',
			July: '07',
			August: '08',
			September: '09',
			October: '10',
			November: '11',
			December: '12',
		};
		return months[monthName] || '01';
	}

	/**
	 * Convert 12-hour time to 24-hour
	 *
	 * @param {string} time Time string (e.g., "10:00 AM")
	 * @return {string} 24-hour time (e.g., "10:00")
	 */
	function convertTo24Hour(time) {
		const match = time.match(/(\d+):(\d+)\s*(AM|PM)/i);
		if (!match) {
			return '10:00';
		}

		let hours = parseInt(match[1], 10);
		const minutes = match[2];
		const period = match[3].toUpperCase();

		if (period === 'PM' && hours < 12) {
			hours += 12;
		} else if (period === 'AM' && hours === 12) {
			hours = 0;
		}

		return `${hours.toString().padStart(2, '0') }:${ minutes}`;
	}

	/**
	 * Add one hour to datetime
	 *
	 * @param {string} datetime Datetime in ICS format
	 * @return {string} Datetime plus one hour
	 */
	function addOneHour(datetime) {
		// Simple implementation - add 1 to hour component
		const hours = parseInt(datetime.substr(9, 2), 10);
		const newHours = ((hours + 1) % 24).toString().padStart(2, '0');
		return datetime.substr(0, 9) + newHours + datetime.substr(11);
	}

	/**
	 * Get current timestamp in ICS format
	 *
	 * @return {string} Timestamp
	 */
	function getCurrentTimestamp() {
		const now = new Date();
		return (
			`${now.getUTCFullYear() +
			(now.getUTCMonth() + 1).toString().padStart(2, '0') +
			now.getUTCDate().toString().padStart(2, '0')
			}T${
				now.getUTCHours().toString().padStart(2, '0')
			}${now.getUTCMinutes().toString().padStart(2, '0')
			}${now.getUTCSeconds().toString().padStart(2, '0')
			}Z`
		);
	}

	/**
	 * Download ICS file
	 *
	 * @param {string} content  ICS file content
	 * @param {string} filename Base filename
	 */
	function downloadICS(content, filename) {
		const blob = new Blob([content], {
			type: 'text/calendar;charset=utf-8',
		});
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download =
			`${filename.replace(/[^a-z0-9]/gi, '_').toLowerCase() }.ics`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
	}
})(jQuery);
